// extracted by mini-css-extract-plugin
export default {"topBar":"TopBar-module__topBar--a8cb6","relativeTime":"TopBar-module__relativeTime--b557b","searchQueriesWrapper":"TopBar-module__searchQueriesWrapper--f7702"};